import React from 'react'
import { Image, Link } from 'newComponents'
import classNames from 'classnames'
import { getHelp } from '../../../utils/thirdPartyUtils'

export default (props) => {
  const { item, toggleOpacity, reduceOpacity = false } = props
  const { url, name, icon } = item
  const reducedOpacity = classNames(
    {
      'submenu-items-opacity-half': reduceOpacity
    },
    'navbar-item'
  )

  return (
    <Link className={reducedOpacity} to={url} onMouseOver={toggleOpacity} onMouseOut={toggleOpacity} tabIndex="0">
      {icon.url && (
        <span className="navbar-item-pre">
          <Image image={icon} alt={name} />
        </span>
      )}
      <span>
        <span className="navbar-item-name submenu-item-name">{name}</span>
      </span>
    </Link>
  )
}
